<script>
export default {
  name: "Pc",
  inject: ['states'],
  render() {
    return this.states.isMobile ? null : this.$slots.default({});
  }
}
</script>

<style scoped>

</style>